import { dimensions, fontFamily, palette } from "../styles/foundation";
import { lighten } from "polished";
import { Link } from "gatsby";
import styled from "styled-components";

// Navigation bar
export const uiNavigation = {
  // Header全体のwrapper
  Nav: styled.nav<{ isOpen: boolean }>`
    padding: 13px 0;
    background-color: ${({ isOpen }) => (isOpen ? palette.ink.normal : "transparent")};

    @media (min-width: ${dimensions.breakPoint + 1}px) {
      padding: 0;
      background-color: transparent;
    }
  `,
  // Flexのcontainer
  Container: styled.div`
    align-items: center;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    line-height: 1.15;
    margin: 0 13px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      align-items: stretch; // Take 100% of height
      background-color: transparent;
      margin: 0;
    }
  `,
  // Logoと大学名と教室名を格納
  LogoLink: styled(Link)`
    background-color: #fff;
    padding: 13px 0 13px 15px;
    display: flex;
    align-items: center;
    &:hover {
      color: inherit;
      text-decoration: none;
    }
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      flex-grow: 1;
      padding: 31px;
      & > svg {
        margin-right: 6px;
        height: calc(2rem + 1rem + 5px);
      }
    }
  `,
  LogoContainer: styled.div`
    display: flex;
    align-items: center;
    margin-right: 10px;
    width: 24px;
    height: 35px;
    & > svg {
      width: 100%;
    }
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      margin-right: 15px;
      width: 27px;
      height: 39px;
    }
  `,
  NameContainer: styled.div`
    display: inline-block;
  `,
  LabName: styled.span`
    display: block;
    font-family: ${fontFamily.serif};
    font-size: 1.6rem;
    letter-spacing: 0.1em;
    margin-bottom: 5px;

    @media (min-width: ${dimensions.breakPoint + 1}px) {
      font-size: 2rem;
      margin-bottom: 5px;
    }
  `,
  // PCのLinkとMenuを可能するコンテナ
  MenuLinkContainer: styled.div`
    display: none;
    margin-left: 10px;
    position: relative;
    width: 25%;
    max-width: 150px;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: flex;
    }
  `,
  // PCのLink (SPでは非表示)
  MenuLink: styled(Link)`
    align-items: center;
    background-color: #fff;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    padding: 5px;
    position: relative;
    text-align: center;
    width: 100%;
    &:hover {
      background-color: ${palette.red.dark};
      color: #fff;
      text-decoration: none;
    }
  `,
  SubMenuContainer: styled.div`
    position: absolute;
    padding-top: 15px;
    top: 100%;
    margin-left: -110px;
    left: 50%;
    width: 220px;
  `,
  // PCのサブメニュー
  Submenu: styled.ul`
    background-color: #fff;
    box-sizing: border-box;
    display: none;
    list-style-type: "・";
    list-style-position: inside;
    padding: 10px 20px;
    position: relative;
    z-index: 10;

    & > li {
      margin: 15px 0;
    }
    &:before {
      content: "";
      position: absolute;
      display: block;
      top: -10px;
      left: 105px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6.5px 10px 6.5px;
      border-color: transparent transparent #ffffff transparent;
    }
  `,
  UnivName: styled.small`
    color: ${palette.red.dark};
    display: block;
    font-size: 1rem;
    font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
  `,
  MenuIconContainer: styled.button`
    margin-right: 6px;
    border: 0;
    background-color: #fff;
    -webkit-tap-highlight-color: transparent;
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: none;
    }
  `,
};

// SPでtoggleするMenu
export const uiSectionSpMenu = {
  SpMenu: styled.div<{ isOpen: boolean }>`
    background-color: ${palette.ink.normal};
    color: #fff;
    display: none;
    padding-top: 20px;
    padding-bottom: 18px;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: 10;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    @media (min-width: ${dimensions.breakPoint + 1}px) {
      display: none;
    }
  `,
  TelContainer: styled.div`
    margin-bottom: 10px;
  `,
  TelIconContainer: styled.div`
    width: 18px;
    height: 21px;
    margin: 17px auto 15px auto;
    path {
      fill: #fff;
    }
  `,
  Tel: styled.div`
    margin-bottom: 15px;
  `,
  TelLink: styled.a`
    color: #fff;
    font-size: 2.6rem;
    font-family: ${fontFamily.serif};
    line-height: 1.2;
    letter-spacing: 0.5rem;
  `,
  TelAnnotation: styled.div`
    font-size: 1.3rem;
    line-height: 1.2;
  `,
  MailContainer: styled.div``,
  MailIconContainer: styled.div`
    width: 18px;
    height: 12px;
    margin: 0 auto 10px auto;
  `,
  MailLink: styled.a`
    color: #fff;
    font-family: ${fontFamily.serif};
    font-size: 1.9rem;
    letter-spacing: 0.1rem;
  `,
  SpMenuList: styled.ul`
    list-style-type: none;
    padding: 0;
    & > li {
      border-bottom: 1px solid #fff;
    }
  `,
  SpMenuLink: styled(Link)`
    align-items: center;
    color: #fff;
    display: flex;
    font-size: 1.5rem;
    justify-content: space-between;
    padding: 5px 26px;
    &:hover {
      background-color: ${lighten(0.05, palette.ink.normal)};
      color: #fff;
    }
  `,
  Copyright: styled.div`
    margin-top: 10px;
    font-size: 1.2rem;
  `,
};
